module.exports = __webpack_public_path__ + "static/media/offer-3.a19f6d23.png";